const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Date',
        dataIndex: 'modifiedDate',
        sorter: true
    },

];


export default columns;